import { Box, Chip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StatusBadge } from '@/shared/components';

interface OfferInfoSectionProps {
  title: string;
  productName?: string;
  condition: 'NEW' | 'USED';
  isClosed?: boolean;
  closureReason?: 'VENTE_CONCLUE' | 'AUTRE' | null;
}

export default function OfferInfoSection({
  title,
  productName,
  condition,
  isClosed = false,
  closureReason,
}: Readonly<OfferInfoSectionProps>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 1,
          mb: 1,
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{ fontWeight: 600, color: 'text.primary', flex: 1 }}
        >
          {title}
        </Typography>
        {isClosed && (
          <Chip
            label={
              closureReason === 'VENTE_CONCLUE'
                ? t('myPublications.status.closedDealConcluded')
                : t('myPublications.status.closed')
            }
            size="small"
            sx={{
              bgcolor: 'error.main',
              color: 'error.contrastText',
              fontWeight: 600,
              flexShrink: 0,
              mt: 0.5,
            }}
            data-testid="offer-detail-closed-badge"
          />
        )}
      </Box>

      {productName && (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2, fontSize: '1rem' }}>
          {productName}
        </Typography>
      )}

      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontSize: '0.875rem' }}>
        {t('search.condition.label')}
      </Typography>

      <StatusBadge status={condition} size="medium" />
    </Box>
  );
}
